(() => {
	const videos = Array.from(document.querySelectorAll('.video-thumbnail'));
	if( videos.length === 0 ) {
		return;
	}
	
	const classNames = {
		ON: 'status-on',
		OFF: 'status-off',
	};
	
	videos.forEach(wrapper => {
		const video = wrapper.querySelector('video');
		const buttons = Array.from(wrapper.querySelectorAll('.video-control'));
		
		const _toggleButtonState = (btn) => {
			const state = btn.classList.contains(classNames.ON) ? 'on' : 'off';
			_setButtonState(btn, state);
		}
		
		const _setButtonState = (btn, state) => {
			if( state === 'on' ) {
				btn.classList.remove(classNames.ON);
				btn.classList.add(classNames.OFF);
				btn.setAttribute('title', btn.dataset.titleOff);
				return;
			}
			
			btn.classList.remove(classNames.OFF);
			btn.classList.add(classNames.ON);
			btn.setAttribute('title', btn.dataset.titleOn);
		}
		
		buttons.forEach(btn => {
			if( btn.classList.contains('control-sound') ) {
				_setButtonState(btn, video.muted ? 'on' : 'off');
			}
			
			
			btn.addEventListener('click', event => {
				event.preventDefault();
				
				if( btn.classList.contains('control-sound') ) {
					_toggleButtonState(btn);
					video.muted = ! video.muted;
				}
			});
		});
		
		
		video.addEventListener('click', () => {
			video.paused ? video.play() : video.pause();
		})
	});
})();





(() => {
	const players = Array.from(document.querySelectorAll('.ytplayer'));
	if( players.length === 0 ) {
		return;
	}
	
	const scriptId = 'ytplayer-js';
	const script = document.getElementById(scriptId);
	
	if(! script ) {
		// Load the IFrame Player API code asynchronously.
		const tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	
	function onYouTubePlayerAPIReady() {
		players.forEach(p => {
			// Replace the 'ytplayer' element with an <iframe> and
			// YouTube player after the API code downloads.
			let player;
			
			const id = p.getAttribute('id');
			const vid = p.dataset.id;
				
			player = new YT.Player(id, {
				autoplay:1,
				controls:0,
				height: '100%',
				width: '100%',
				modestbranding:1,
				videoId: vid,
				iv_load_policy:3,
				loop:1,
				rel:0,
				showinfo:0,
			});
		});
	}
	
	window.onYouTubePlayerAPIReady = onYouTubePlayerAPIReady;
})();